/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLivestockAttentionAnimalCountsQueryResponse, GetLivestockAttentionAnimalCountsPathParams, GetLivestockAttentionAnimalCountsQueryParams, GetLivestockAttentionAnimalCounts400, GetLivestockAttentionAnimalCounts401, GetLivestockAttentionAnimalCounts403, GetLivestockAttentionAnimalCounts404, GetLivestockAttentionAnimalCounts409, GetLivestockAttentionAnimalCounts500 } from "../../types/livestockController/GetLivestockAttentionAnimalCounts.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLivestockAttentionAnimalCountsUrl(organizationId: GetLivestockAttentionAnimalCountsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/livestock-attention/animal-counts` as const }
  return res
}

/**
 * @summary Per-animal attention totals for list/card badges (exact per page)
 * {@link /api/organizations/:organizationId/livestock-attention/animal-counts}
 */
export async function getLivestockAttentionAnimalCounts(organizationId: GetLivestockAttentionAnimalCountsPathParams["organizationId"], params: GetLivestockAttentionAnimalCountsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLivestockAttentionAnimalCountsQueryResponse, ResponseErrorConfig<GetLivestockAttentionAnimalCounts400 | GetLivestockAttentionAnimalCounts401 | GetLivestockAttentionAnimalCounts403 | GetLivestockAttentionAnimalCounts404 | GetLivestockAttentionAnimalCounts409 | GetLivestockAttentionAnimalCounts500>, unknown>({ method : "GET", url : getGetLivestockAttentionAnimalCountsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}